const brainwave = '/assets/brainwave.svg';
const check = '/assets/check.svg';
const brainwaveSymbol = '/assets/brainwave-symbol.svg';
const brainwaveWhiteSymbol = '/assets/brainwave-symbol-white.svg';
const play = '/assets/play.svg';
const gradient = '/assets/gradient.png';
const smallSphere = '/assets/4-small.png';
const grid = '/assets/grid.png';
const check2 = '/assets/check-02.svg';
const loading1 = '/assets/loading-01.svg';
const yourlogo = '/assets/yourlogo.svg';
const homeSmile = '/assets/home-smile.svg';
const file02 = '/assets/file-02.svg';
const searchMd = '/assets/search-md.svg';
const plusSquare = '/assets/plus-square.svg';
const recording03 = '/assets/recording-03.svg';
const recording01 = '/assets/recording-01.svg';
const disc02 = '/assets/disc-02.svg';
const chromecast = '/assets/chrome-cast.svg';
const sliders04 = '/assets/sliders-04.svg';
const loading = '/assets/loading.png';
const background = '/assets/background.jpg';

const curve = '/assets/hero/curve.png';
const robot = '/assets/hero/robot.jpg';
const heroBackground = '/assets/hero/hero-background.jpg';

const curve1 = '/assets/collaboration/curve-1.svg';
const curve2 = '/assets/collaboration/curve-2.svg';
const discord = '/assets/collaboration/discord.png';
const figma = '/assets/collaboration/figma.png';
const framer = '/assets/collaboration/framer.png';
const notion = '/assets/collaboration/notion.png';
const photoshop = '/assets/collaboration/photoshop.png';
const protopie = '/assets/collaboration/protopie.png';
const raindrop = '/assets/collaboration/raindrop.png';
const slack = '/assets/collaboration/slack.png';

const service1 = '/assets/services/service-1.png';
const service2 = '/assets/services/service-2.png';
const service3 = '/assets/services/service-3.png';

const lines = '/assets/pricing/lines.svg';
const stars = '/assets/pricing/stars.svg';

const coins = '/assets/roadmap/coins.png';
const done = '/assets/roadmap/done.svg';
const hero = '/assets/roadmap/hero.png';
const roadmap1 = '/assets/roadmap/image-1.png';
const roadmap2 = '/assets/roadmap/image-2.png';
const roadmap3 = '/assets/roadmap/image-3.png';
const roadmap4 = '/assets/roadmap/image-4.png';
const undone = '/assets/roadmap/undone.svg';

const notification1 = '/assets/notification/image-1.png';
const notification2 = '/assets/notification/image-2.png';
const notification3 = '/assets/notification/image-3.png';
const notification4 = '/assets/notification/image-4.png';

const benefitCard1 = '/assets/benefits/card-1.svg';
const benefitCard2 = '/assets/benefits/card-2.svg';
const benefitCard3 = '/assets/benefits/card-3.svg';
const benefitCard4 = '/assets/benefits/card-4.svg';
const benefitCard5 = '/assets/benefits/card-5.svg';
const benefitCard6 = '/assets/benefits/card-6.svg';
const benefitIcon1 = '/assets/benefits/icon-1.svg';
const benefitIcon2 = '/assets/benefits/icon-2.svg';
const benefitIcon3 = '/assets/benefits/icon-3.svg';
const benefitIcon4 = '/assets/benefits/icon-4.svg';
const benefitImage2 = '/assets/benefits/image-2.png';

const discordBlack = '/assets/socials/discord.svg';
const facebook = '/assets/socials/facebook.svg';
const instagram = '/assets/socials/instagram.svg';
const telegram = '/assets/socials/telegram.svg';
const twitter = '/assets/socials/twitter.svg';

export {
  background,
  benefitCard1,
  benefitCard2,
  benefitCard3,
  benefitCard4,
  benefitCard5,
  benefitCard6,
  benefitIcon1,
  benefitIcon2,
  benefitIcon3,
  benefitIcon4,
  benefitImage2,
  brainwave,
  brainwaveSymbol,
  brainwaveWhiteSymbol,
  check,
  check2,
  chromecast,
  coins,
  curve,
  curve1,
  curve2,
  disc02,
  discord,
  discordBlack,
  done,
  facebook,
  figma,
  file02,
  framer,
  gradient,
  grid,
  hero,
  heroBackground,
  homeSmile,
  instagram,
  lines,
  loading,
  loading1,
  notification1,
  notification2,
  notification3,
  notification4,
  notion,
  photoshop,
  play,
  plusSquare,
  protopie,
  raindrop,
  recording01,
  recording03,
  roadmap1,
  roadmap2,
  roadmap3,
  roadmap4,
  robot,
  searchMd,
  service1,
  service2,
  service3,
  slack,
  sliders04,
  smallSphere,
  stars,
  telegram,
  twitter,
  undone,
  yourlogo,
};
